import router from '@/router'
import { DateTime } from 'luxon'
import { useFormStore } from '@/stores/form'
import useFormatDate from '@/composables/useFormatDate'

export default function () {
  const formStore = useFormStore()
  const { formateDateFromDDMMYYYY } = useFormatDate()
  const birthday =
    formStore.form.values.dateOfBirth &&
    formateDateFromDDMMYYYY(formStore.form.values.fatherDateOfBirth)

  return {
    serviceTransactionId: router.currentRoute.value.params.serviceId,
    dateOfBirth:
      birthday &&
      DateTime.now().diff(birthday, 'years').years &&
      Math.floor(DateTime.now().diff(birthday, 'years').years),

    familyBooKFamilySequence: formStore.form.values.familyBooKFamilySequence,
    maritalStatusId: formStore.form.values.maritalStatusId,
    identifierTypeId: formStore.form.values.identifierTypeId,
    identificater: formStore.form.values?.edit_childrensInfoList?.identificater
  }
}
